import { render, staticRenderFns } from "./IssuesList.vue?vue&type=template&id=95e38f6a&scoped=true&"
import script from "./IssuesList.vue?vue&type=script&lang=js&"
export * from "./IssuesList.vue?vue&type=script&lang=js&"
import style0 from "./IssuesList.vue?vue&type=style&index=0&id=95e38f6a&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "95e38f6a",
  null
  
)

export default component.exports